export default "__VITE_ASSET__DRq0Raub__"